import { CamposDatosMarca } from "@/apollo/queries/mail";
import gql from "graphql-tag";

export const PUT_DATOS_MARCA = gql`
mutation CreateUpdateDatosMarca(
    $idTipografiaHeader: Int!, 
    $idTipografiaBody: Int!, 
    $colores: [ColoresInputMarca]!, 
    $imagen: LogoInputMarca!, 
    $idMarca: Int
  ) {
    CreateUpdateDatosMarca(
      id_marca: $idMarca,
      id_tipografia_header: $idTipografiaHeader, 
      id_tipografia_body: $idTipografiaBody, 
      colores: $colores, 
      imagen: $imagen
    )   
  ${CamposDatosMarca}
}
`;

export const DELETE_MAIL = gql`
  mutation DeleteCorreo($idCorreo: Int!) {
    DeleteCorreo(id_correo: $idCorreo) {
      id_correo
    }
  }
`;

export const SAVE_MAIL = gql`
  mutation SaveCorreo(
    $idCorreo: Int
    $idRemitente: Int!
    $nombreRemitente: String!
    $asunto: String!
    $introduccion: String
    $archivosAdjuntos: [FileAdjuntosInput!]
    $destinatarios: DestinatariosInputObject!
    $contenidoHtml: String
    $contenidoJson: String
    $isTemplate: Boolean
    $isEraser: Boolean
    $isProgrammed: Boolean
    $fechaProgramada: String
    $horaProgramada: String
    $urlImagenTemplate: String
    $formatoImagenTemplate: String
    $idCategoriaFk: Int
    $varDinamicas: Boolean
  ) {
    SaveCorreo(
      id_correo: $idCorreo
      id_remitente: $idRemitente
      nombre_remitente: $nombreRemitente
      asunto: $asunto
      introduccion: $introduccion
      archivos_adjuntos: $archivosAdjuntos
      destinatarios: $destinatarios
      contenido_html: $contenidoHtml
      contenido_json: $contenidoJson
      is_template: $isTemplate
      is_eraser: $isEraser
      is_programmed: $isProgrammed
      fecha_programada: $fechaProgramada
      hora_programada: $horaProgramada
      url_imagen_template: $urlImagenTemplate
      formato_imagen_template: $formatoImagenTemplate
      id_categoria_fk: $idCategoriaFk
      var_dinamicas: $varDinamicas
    ) {
      
      
    id_correo
    remitente {
      id_remitente
      nombre_remitent
      correo_remitente
      id_estado_fk
    }
    nombre_remitente
    asunto
    introduccion
    adjuntos {
      id_adjunto
      url_adjunto
      nombre_adjunto
      size
    }
    destinatarios {
      usuario {
        apellido_paterno
        primer_nombre
        rut_usuario
        dv_usuario
        id_usuario
      }
      lista {
        id_lista
        nombre_lista
      }
    }
    estado {
      id_estado
      nombre_estado
      color
      orden
      is_initialization
      is_deleted
      is_sended
    }
    categoria {
      id_categoria
      nombre_categoria
      color
    }
    contenido_html
    contenido_json
    fecha_envio
    correos_detinados
    correos_enviados
    tasa_apertura
    tasa_acciones
    porcentaje_apertura
    tasa_play_video
    fecha_creacion



    }
  }
`;

export const DELETE_MAIL_ATTACHMENT = gql`
  mutation DeleteArchivoAdjunto($idAdjunto: [Int!]!) {
    DeleteArchivoAdjunto(id_adjunto: $idAdjunto) {
      id_correo
      adjuntos {
        id_adjunto
      }
    }
  }
`;

export const CREATE_MAIL_CATEGORIA = gql`
  mutation CreateCategoriasTemplates(
    $nombreCategoria: String!
    $color: String!
    $tipoCategoria: Int!
  ) {
    CreateCategoriasTemplates(
      nombre_categoria: $nombreCategoria
      color: $color
      tipo_categoria: $tipoCategoria
    ) {
      id_categoria
      nombre_categoria
      color
    }
  }
`;
export const UPDATE_MAIL_CATEGORIA = gql`
  mutation UpdateCategoriasTemplates(
    $idCategoria: Int!
    $nombreCategoria: String!
    $color: String!
  ) {
    UpdateCategoriasTemplates(
      id_categoria: $idCategoria
      nombre_categoria: $nombreCategoria
      color: $color
    ) {
      id_categoria
      nombre_categoria
      color
    }
  }
`;
export const DELETE_MAIL_CATEGORIA = gql`
  mutation DeleteCategoriasTemplates($idCategoria: Int!) {
    DeleteCategoriasTemplates(id_categoria: $idCategoria) {
      id_categoria
    }
  }
`;

export const CREATE_MAIL_CONTACTOS_LISTA = gql`
  mutation CreateOrUpdateListaContactos(
    $nombre_lista: String!
    $id_lista: Int!
    $id_cargo: [Int]!
    $id_gerencia: [Int]!
    $id_sucursal: [Int]!
    $id_usuario: [Int]!
  ) {
    CreateOrUpdateListaContactos(
      nombre_lista: $nombre_lista
      id_lista: $id_lista
      id_cargo: $id_cargo
      id_gerencia: $id_gerencia
      id_sucursal: $id_sucursal
      id_usuario: $id_usuario
    ) {
      id_lista
      nombre_lista
      destinatarios {
        id_destinatario
        tipo_destinatario
        variable_destinatario
        datos {
          id
          nombre
          lista {
            apellido_paterno
            correo
            primer_nombre
            id_usuario
          }
        }
      }
    }
  }
`;

export const DELETE_MAIL_CONTACTOS_LISTA = gql`
  mutation DeleteListaContactos($idLista: Int!) {
    DeleteListaContactos(id_lista: $idLista) {
      id_lista
      nombre_lista
    }
  }
`;

export const DELETE_TEMPLATE = gql`
mutation DeleteTemplate($idTemplate: Int!) {
  DeleteTemplate(id_template: $idTemplate) {
    id_categoria_fk
    id_template
  }
}
`;

export const CREATE_AUTOMATED_TEMPLATE = gql`
  mutation CreateTemplate(
    $asunto: String!
    $introduccion: String!
    $idRemitente: Int!
    $urlImagen: String!
    $formatoImagen: String!
    $idCategoriaFk: Int!
    $contenidoHtml: String!
    $contenidoJson: String!
    $isAutomatico: Boolean!
    $byIngreso: Boolean!
    $byNacimiento: Boolean!
    $cadenciaEnvio: Int!
    $isActive: Boolean!
    $diaEnvio: Int!
    $fechaEnvio: String!
    $horaEnvio: String!
    $destinatarios: DestinatariosInputObject
    $archivosAdjuntos: [FileAdjuntosInput]
  ) {
    CreateTemplate(
      asunto: $asunto
      introduccion: $introduccion
      id_remitente: $idRemitente
      url_imagen: $urlImagen
      formato_imagen: $formatoImagen
      id_categoria_fk: $idCategoriaFk
      contenido_html: $contenidoHtml
      contenido_json: $contenidoJson
      is_automatico: $isAutomatico
      by_ingreso: $byIngreso
      by_nacimiento: $byNacimiento
      cadencia_envio: $cadenciaEnvio
      is_active: $isActive
      dia_envio: $diaEnvio
      fecha_envio: $fechaEnvio
      hora_envio: $horaEnvio
      destinatarios: $destinatarios
      archivos_adjuntos: $archivosAdjuntos
    ) {
      id_template
      descripcion
      titulo
    }
  }
`;